import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/14090482ad00f674843640af3b243289/95d6b32e551f6aac9c08a7e8cf214df7.jfif')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 z-10"></div>
      
      {/* Content */}
      <div className="relative z-20 flex flex-col items-center justify-center px-6 py-24 text-center max-w-6xl mx-auto">
        <span className="text-indigo-400 font-medium mb-4 text-lg">
          {t('heroSubtitle')}
        </span>
        
        <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight text-white">
          {t('heroTitle1')}
          <br />
          <span className="bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
            {t('heroTitle2')}
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl leading-relaxed">
          {t('heroDescription')}
        </p>
        
        <div className="flex flex-col sm:flex-row items-center gap-6 mb-12">
          <Button 
            onClick={() => scrollToSection('features')}
            size="lg"
            className="px-16 py-5 text-xl rounded-full shadow-[0_0_30px_rgba(99,102,241,0.4)] hover:shadow-[0_0_40px_rgba(99,102,241,0.6)] hover:scale-105"
          >
            {t('learnMore')}
          </Button>
          
          <Button 
            onClick={() => scrollToSection('contact')}
            variant="outline"
            size="lg"
            className="px-16 py-5 text-xl rounded-full border-white/30 text-white hover:bg-white hover:text-gray-900"
          >
            {t('freeTrial')}
          </Button>
        </div>
        
        {/* Social Proof */}
        <div className="flex items-center gap-8 mt-8">
          <div className="flex -space-x-4">
            <img 
              src="https://static.readdy.ai/image/14090482ad00f674843640af3b243289/54ca0c40d9bd6cb1801336d427c47f45.png" 
              alt={t('gameIcon')}
              className="w-12 h-12 rounded-full border-2 border-white"
            />
            <img 
              src="https://static.readdy.ai/image/14090482ad00f674843640af3b243289/b317d129a6422ee6d3854f897175c8b7.png" 
              alt={t('gameIcon')}
              className="w-12 h-12 rounded-full border-2 border-white"
            />
            <img 
              src="https://static.readdy.ai/image/14090482ad00f674843640af3b243289/6057b9ff9923c6ede780332acd06930b.png" 
              alt={t('gameIcon')}
              className="w-12 h-12 rounded-full border-2 border-white"
            />
          </div>
          
          <div className="flex items-center gap-2">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill ri-sm text-yellow-400"></i>
              ))}
            </div>
            <p className="text-gray-300 ml-2">{t('socialProof')}</p>
          </div>
        </div>

        {/* YouTube Video */}
        <div className="mt-16 w-full max-w-4xl">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl shadow-2xl"
              src="https://www.youtube.com/embed/B_SmkvYwBVg"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}